webpackJsonp([249972491463148],{

/***/ 1693:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Gremlinz-White-Transp.54c275c0.png";

/***/ }),

/***/ 1694:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Gremlinz_back_small1.2fe55225.jpg";

/***/ }),

/***/ 1695:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/back4.b4412d5c.jpg";

/***/ }),

/***/ 1027:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(72);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(568);
	
	var _reactHelmet = __webpack_require__(129);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Products = __webpack_require__(494);
	
	var _Products2 = _interopRequireDefault(_Products);
	
	var _Footer = __webpack_require__(259);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(505);
	
	__webpack_require__(506);
	
	var _back = __webpack_require__(1695);
	
	var _back2 = _interopRequireDefault(_back);
	
	var _Gremlinz_back_small = __webpack_require__(1694);
	
	var _Gremlinz_back_small2 = _interopRequireDefault(_Gremlinz_back_small);
	
	var _GremlinzWhiteTransp = __webpack_require__(1693);
	
	var _GremlinzWhiteTransp2 = _interopRequireDefault(_GremlinzWhiteTransp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Apparel = function (_Component) {
	  _inherits(Apparel, _Component);
	
	  function Apparel() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Apparel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      filteredProducts: undefined,
	      noSearchResults: false
	    }, _this.handleFilterClick = function (e, titleProps) {
	      var index = titleProps.index;
	      var activeFilterIndex = _this.state.activeFilterIndex;
	
	      var newIndex = activeFilterIndex === index ? -1 : index;
	
	      _this.setState({ activeFilterIndex: newIndex });
	    }, _this.getHeaderImage = function () {
	      if (typeof window !== "undefined" && window.screen.width < 600) {
	        return _Gremlinz_back_small2.default;
	      }
	      return _back2.default;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Apparel.prototype.filterProductsByType = function filterProductsByType(productType) {
	    var _this2 = this;
	
	    var filtered = [];
	    // add the loading css
	    this.props.client.product.fetchAll(30).then(function (products) {
	      // fetch all products and filter by productType
	      products.forEach(function (product) {
	        if (product.productType === productType) {
	          filtered.push(product);
	        }
	      });
	
	      // if the length is greater than 0, add the products, else set noSearchResults to true
	      if (filtered.length > 0) {
	        _this2.setState({ filteredProducts: filtered });
	      } else {
	        _this2.setState({
	          noSearchResults: true
	        });
	      }
	    });
	  };
	
	  Apparel.prototype.componentDidMount = function componentDidMount() {
	    this.filterProductsByType("Kodak");
	
	    // add different page style
	    document.querySelector(".footer__links").classList.add("catalog");
	    document.querySelector(".sideBar").classList.add("catalog");
	    document.querySelector(".sideBar__btn").classList.add("catalog");
	    document.querySelectorAll("li.topBar__link a").forEach(function (el) {
	      return el.classList.add("catalog");
	    });
	
	    this.props.handleCartClose();
	  };
	
	  Apparel.prototype.render = function render() {
	    //find all the product types and filter to remove duplicates
	    var productTypes = this.props.products.map(function (product) {
	      return product.productType;
	    }).filter(function (val, index, self) {
	      return self.indexOf(val) === index;
	    }).map(function (type) {
	      return _react2.default.createElement(
	        "li",
	        { key: type },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/en/Catalog/" + type },
	          type
	        )
	      );
	    });
	
	    // let collections = this.props.collections.map(collection => {
	    //   return (
	    //     <li key={collection.title}>
	    //       {collection.title}
	    //     </li>
	    //   )
	    // });
	
	    var activeFilterIndex = this.state.activeFilterIndex;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "kodak" },
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: "Mile High Boys Club | Catalog | Kodak",
	        meta: [{
	          name: "description",
	          content: "Mile High Boys Club official website and merch store. Hats Catalog Page."
	        }, {
	          name: "keywords",
	          content: "Mile High Boys Club, MHBC, MHBC Fashion, fashion"
	        }]
	      }),
	      _react2.default.createElement(
	        "header",
	        { id: "catalogHeader" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "catalogHeaderContent" },
	            _react2.default.createElement("img", { src: this.getHeaderImage(), alt: "" }),
	            _react2.default.createElement("div", { className: "catalogHeaderContent__filter" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "catalogHeader__text" },
	            _react2.default.createElement("img", { src: _GremlinzWhiteTransp2.default, alt: "" })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "catalogCategory" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/" },
	              "Home"
	            ),
	            " \u2192",
	            " ",
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/en/Catalog" },
	              "Catalog"
	            ),
	            " \u2192 Gremlinz Collection 2022"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            this.state.filteredProducts ? this.state.filteredProducts.length : 0,
	            " ",
	            "results",
	            _react2.default.createElement("span", null)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "main",
	        { id: "catalogMain" },
	        _react2.default.createElement(
	          "div",
	          { className: "catalogFilter" },
	          _react2.default.createElement(
	            "div",
	            { className: "filter" },
	            _react2.default.createElement(
	              _semanticUiReact.Accordion,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Accordion.Title,
	                {
	                  active: activeFilterIndex === 1,
	                  index: 1,
	                  onClick: this.handleFilterClick
	                },
	                _react2.default.createElement(
	                  "label",
	                  null,
	                  "Filter By"
	                ),
	                _react2.default.createElement(_semanticUiReact.Icon, { name: "dropdown" })
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Accordion.Content,
	                { active: activeFilterIndex === 1 },
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  productTypes
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Products2.default, {
	          products: this.state.filteredProducts,
	          client: this.props.client,
	          addVariantToCart: this.addVariantToCart,
	          noProductsFound: this.state.noSearchResults
	        })
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return Apparel;
	}(_react.Component);
	
	exports.default = Apparel;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-catalog-kodak-en-js-834c3750416246a9b733.js